// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"e90fabfc","225":"93f5f59a","787":"fa9cb370"}[chunkId] + ".chunk.js";
};